import { ButtonGroupProps } from 'react-multi-carousel';
import CarouselNavigation from '@/components/Carousel/CarouselNavigation';

interface NavigationProps extends ButtonGroupProps {
  className?: string;
  items: number;
  offset?: number;
}

export const Navigation = ({ next, previous, goToSlide, carouselState, items, offset = 0 }: NavigationProps) => {
  const noop = () => {};
  const { currentSlide } = carouselState || {};

  return currentSlide != null ? (
    <CarouselNavigation
      items={Array(items).fill(0)}
      activeIndex={(currentSlide + items - offset) % items}
      onPreviousItem={previous || noop}
      onItemClick={(index: number) => {
        // enabling infinite on the wrapping component causes the offset to be needed. TODO: further investigation as to how it works in different configurations
        goToSlide && currentSlide && goToSlide(index + offset);
      }}
      onNextItem={next || noop}
    />
  ) : null;
};
